export { FooterMenu } from './FooterMenu/footermenu';
export { FooterLegalMenu } from './FooterLegalMenu/footerlegalmenu';
export { FooterSocialMenu } from './FooterSocialMenu/footersocialmenu';
